import { Set } from "./Set";

export class Position {
    public x: number;
    public y: number;
    public width: number;
    public height: number;
    public set: Set;

    constructor(x: number, y: number, width: number, height: number, set: Set) {
        if (x < 0)
            throw new Error(`Relative left position of activity in the set '${set.name}' cannot be less then zero!`);

        if (y < 0)
            throw new Error(`Relative top position of activity in the set '${set.name}' cannot be less then zero!`);

        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.set = set;
    }
}
